export default __webpack_public_path__ + "static/glass-10-15395288bda723b272a0076dcc5e7ac8.jpg";